export default {
  GET_ALL_AVAILABLE_DOCUMENT_MASSIVE_DOWNLOAD: 'GET_ALL_AVAILABLE_DOCUMENT_MASSIVE_DOWNLOAD',
  GET_ALL_AVAILABLE_DOCUMENT_MASSIVE_DOWNLOAD_SUCESS: 'GET_ALL_AVAILABLE_DOCUMENT_MASSIVE_DOWNLOAD_SUCESS',
  DOWNLOAD_DOCUMENTS_MASSIVE_DOWNLOAD: 'DOWNLOAD_DOCUMENTS_MASSIVE_DOWNLOAD'
}
